// Плавный счёт цифр при появлении и смене значения; «меньше движения» — сразу итоговое число. [Claude, 04.11.2026]
import { onBeforeUnmount, ref, watch } from 'vue'

export function useCountUp(source, { duration = 650 } = {}) {
  const shown = ref(0)
  let frame = 0
  const reduce = typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
  function run(to) {
    cancelAnimationFrame(frame)
    const target = Number(to) || 0
    if (reduce || typeof requestAnimationFrame === 'undefined') { shown.value = target; return }
    const from = shown.value
    const start = performance.now()
    const step = (now) => {
      const k = Math.min(1, (now - start) / duration)
      const ease = 1 - Math.pow(1 - k, 3)
      shown.value = from + (target - from) * ease
      if (k < 1) frame = requestAnimationFrame(step)
    }
    frame = requestAnimationFrame(step)
  }
  watch(source, run, { immediate: true })
  onBeforeUnmount(() => cancelAnimationFrame(frame))
  return shown
}
